(() => {
  const init = (root) => {
    if (!root || root.dataset.hvReady) return;
    root.dataset.hvReady = 'true';
    const slides = [...root.querySelectorAll('[data-hv-slide]')];
    const dots = [...root.querySelectorAll('[data-hv-dot]')];
    let index = 0;
    let timer;
    let paused = false;
    const show = (next) => {
      if (!slides.length) return;
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.hidden = i !== index;
        slide.classList.toggle('is-active', i === index);
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-pressed', String(i === index));
      });
    };
    const stop = () => { clearInterval(timer); timer = undefined; };
    const start = () => {
      stop();
      if (root.dataset.autoplay === 'true' && slides.length > 1 && !paused && !document.hidden && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = setInterval(() => show(index + 1), Number(root.dataset.interval) || 7000);
      }
    };
    root.querySelector('[data-hv-prev]')?.addEventListener('click', () => { show(index - 1); start(); });
    root.querySelector('[data-hv-next]')?.addEventListener('click', () => { show(index + 1); start(); });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); start(); }));
    root.querySelector('[data-hv-pause]')?.addEventListener('click', (event) => {
      paused = !paused;
      event.currentTarget.textContent = paused ? '▷' : 'Ⅱ';
      event.currentTarget.setAttribute('aria-label', paused ? 'Play automatic slideshow' : 'Pause automatic slideshow');
      start();
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', start);
    root.addEventListener('keydown', event => {
      if (slides.length < 2) return;
      if (event.target.closest('input,textarea,select')) return;
      if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1); }
    });
    root.addEventListener('hv:show-slide', event => show(event.detail.index));
    root.querySelectorAll('[data-hv-subscribe]').forEach(button => button.addEventListener('click', () => {
      const popup = document.getElementById('EntryModal');
      if (!popup) {
        document.getElementById('hvl-app')?.scrollIntoView({ behavior: 'smooth' });
        return;
      }
      if (document.querySelector('.pswp.pswp--open') || document.querySelector('.hv-launch-dialog[open]')) {
        popup.querySelector('input[type=email]')?.focus();
        return;
      }
      const owner = popup.parentNode;
      const sibling = popup.nextSibling;
      const previousHidden = popup.getAttribute('aria-hidden');
      const wasLocked = document.body.classList.contains('active_modal');
      const dialog = document.createElement('dialog');
      dialog.className = 'hv-launch-dialog';
      dialog.setAttribute('aria-label', 'Hearview Lite launch updates');
      document.body.appendChild(dialog);
      dialog.appendChild(popup);
      popup.setAttribute('aria-hidden', 'false');
      const closeButton = popup.querySelector('.modal_close_btn');
      const close = event => { event.stopPropagation(); dialog.close(); };
      closeButton?.addEventListener('click', close, true);
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = popup.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        closeButton?.removeEventListener('click', close, true);
        if (previousHidden === null) popup.removeAttribute('aria-hidden');
        else popup.setAttribute('aria-hidden', previousHidden);
        if (sibling?.parentNode === owner) owner.insertBefore(popup, sibling);
        else owner.appendChild(popup);
        if (!wasLocked) document.body.classList.remove('active_modal');
        dialog.remove();
        button.focus();
      }, { once: true });
      dialog.showModal();
      document.body.classList.add('active_modal');
      popup.querySelector('input[type=email]')?.focus();
    }));
    show(0);
    start();
    root.hvStop = stop;
  };
  const all = (scope = document) => scope.querySelectorAll('[data-hv-launch],[data-hv-subscribe-root]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => all());
  else all();
  document.addEventListener('shopify:section:load', event => all(event.target));
  document.addEventListener('shopify:block:select', event => {
    const root = event.target.closest('[data-hv-launch]');
    if (!root) return;
    const slides = [...root.querySelectorAll('[data-hv-slide]')];
    const slide = event.target.closest('[data-hv-slide]');
    const index = slides.indexOf(slide);
    if (index >= 0) { root.hvStop?.(); root.dispatchEvent(new CustomEvent('hv:show-slide', { detail: { index } })); }
  });
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-hv-launch]').forEach(root => root.hvStop?.()));
})();
